<template>
  <v-container>
    <v-layout justify-center wrap>
      <v-flex xs12 md10 lg8>
        <v-card
          color="primary"
          class="pb-5"
          style="text-align: center; margin: auto"
        >
          <h1 class="mb-4">Repair Orders</h1>
          <div v-for="(item, index) in steps" :key="index">
            <v-btn
              class="mx-auto"
              :style="{ width: '80%' }"
              @click="buttonPressed(item)"
              >{{ item.name }}</v-btn
            >
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LoginCheck from "@/mixins/LoginCheck";

export default {
  name: "repair-home",
  data() {
    return {
      steps: [
        // {
        //   name: "Testing",
        //   route: "testing",
        // },
        {
          name: "Pre-Cleaning",
          route: "pre-cleaning",
        },
        {
          name: "Polishing",
          route: "polishing",
        },
        {
          name: "Post-Cleaning",
          route: "cleaning",
        },
      ],
    };
  },

  components: {},

  mixins: [LoginCheck],

  methods: {
    buttonPressed(button) {
      this.$router.push(`/repairs/${button.route}`);
    },
  },
};
</script>

<style>
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
